import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=34cbde1d&"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js&"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSidebar.vue?vue&type=style&index=0&id=34cbde1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports